<ng-container *ngIf="vm$ | async as vm">
  <div class="cart">
    <mat-card appearance="outlined" [class]="editable ? 'mat-elevation-z2' : 'mat-elevation-z0'" class="spacing--margin-bottom spacing--padding-bottom">
      <ng-container *ngIf="cart?.type === orderTypes.preSalesOrder; else defaultCartTitle">
        <mat-card-title>
          <p class="spacing--margin-none-vertical text--bold text--body" data-test="pre-sales__advisor-title">
            {{
              cart?.metadata?.advisorName
                ? locale.translate('cart.cart-by-advisor-title', {
                    advisorName: cart.metadata.advisorName,
                  })
                : ('cart.cart-by-unknown-advisor-title' | translate)
            }}
          </p>
        </mat-card-title>
        <div class="spacing--margin-bottom">
          <div class="notification notification-info text--input-small flex--row" data-test="cart__created-by-advisor-description">
            <mat-icon class="flex--align-self-center">info</mat-icon>
            <div>
              {{
                cart?.metadata?.advisorName
                  ? locale.translate('cart.cart-by-advisor-description', {
                      advisorName: cart.metadata.advisorName,
                    })
                  : ('cart.cart-by-unknown-advisor-description' | translate)
              }}
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #defaultCartTitle>
        <mat-card-title-group>
          <mat-card-title>
            <p class="spacing--margin-none-vertical text--bold text--body" *ngIf="cart.type !== orderTypes.returnableOrder; else returnTitle">
              {{ 'cart.cart' | translate }}
            </p>
          </mat-card-title>
        </mat-card-title-group>
        <div class="flex--row flex--align-end flex--justify-space-between">
          <app-customer-blocked-notification *ngIf="vm.location?.orderBlock"></app-customer-blocked-notification>
          <app-search *ngIf="editable && !vm.location?.orderBlock" [cart]="cart" [showAddProductsReminder]="true" [editable]="editable"></app-search>
          <div id="container">
            <div
              id="oneDayDeliveryContainer"
              *ngIf="editable && isOneDeliveryDateVisible$ | async"
              class="flex--align-center spacing--margin-right spacing--margin-bottom flex flex--justify-space-between"
            >
              <button
                class="left-button"
                color="accent"
                mat-flat-button
                (click)="sendOneDayDeliveryRequest()"
                [disabled]="(isOneDeliveryDateEnabled$ | async) === false"
              >
                <mat-label>{{ 'cart.one-day-delivery.label' | translate }}</mat-label>
              </button>
              <button color="accent" mat-flat-button (click)="openCartDatePicker()" [disabled]="(isOneDeliveryDateEnabled$ | async) === false">
                <mat-label>{{ 'cart.choose-flexibility.label' | translate }}</mat-label>
              </button>
              <mat-icon (click)="openOneDayDeliveryHelpModal()" class="spacing--margin-left cart__help-icon-clickable" data-test="cart__ordertype-help-icon">
                help_outline
              </mat-icon>
            </div>
            <div id="orderTypeContainer">
              <mat-form-field appearance="fill" [class.orderTypeDrowpdownMobile]="isMobileDisplay$ | async">
                <mat-label>{{ 'cart.cart-order-type.label' | translate }}</mat-label>
                <mat-select [formControl]="orderTypeControl" data-test="cart__ordertype-dropdown">
                  <mat-option *ngFor="let option of orderTypeOptions$ | async" [value]="option.value">
                    {{ option.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-icon (click)="openOrderTypeHelpModal()" class="spacing--margin-left cart__help-icon-clickable" data-test="cart__ordertype-help-icon"
                >help_outline
              </mat-icon>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            cart?.type === orderTypes.emergencyOrder ||
            cart?.type === orderTypes.rushOrder ||
            cart?.type === orderTypes.returnableOrder ||
            cart?.type === orderTypes.grainPreSalesOrder
          "
          class="notification notification-info text--input-small flex--row spacing--margin-none-top"
          data-test="cart__rush-emergency-return-notification"
        >
          <mat-icon class="flex--align-self-center">info</mat-icon>
          <div>{{ 'cart.cart-notification-' + cart.type | translate }}</div>
        </div>

        <app-price-notification *ngIf="cartScreenType === 'confirmation' && isUserAtLeastAdvisor$ | async" [cart]="cart"></app-price-notification>

        <div
          *ngIf="topLevelClosingTimeWarning"
          [class]="'notification-' + ((topLevelClosingTimeWarning.severityLevel | lowercase) || 'error')"
          class="notification text--input-small flex--row spacing--margin-none-top"
          data-test="cart__top-level-closing-time-notification"
        >
          <mat-icon class="flex--align-self-center">
            {{ (topLevelClosingTimeWarning.severityLevel | lowercase) || 'error' }}
          </mat-icon>
          <div>
            {{ topLevelClosingTimeWarning | formatValidationMessage }}
          </div>
        </div>
      </ng-template>

      <mat-card-content class="spacing--margin-bottom spacing--margin-negative-horizontal">
        <ng-container *ngIf="tableConfig?.dataSource?.data?.length && tableConfig.columns?.length">
          <agr-table
            [config]="tableConfig"
            [emptyDescription]=""
            [emptyTitle]="'cart.empty-title' | translate"
            [extendAccordion]="extendAccordionMobile"
            data-test="cart-component__agr-table"
          >
          </agr-table>
        </ng-container>
      </mat-card-content>

      <mat-card-actions *ngIf="editable">
        <div class="flex--justify-end flex--align-center">
          <button (click)="delete()" *ngIf="vm.isAtLeastAdvisorOrSalesOrder" class="cart__delete" data-test="cart__delete-cart" mat-flat-button>
            <mat-icon>delete_outline</mat-icon>
            <span *ngIf="cart.type !== orderTypes.returnableOrder; else deleteReturn">{{
              (vm.returnUrl?.length ? 'cart.delete-cart-and-back' : 'cart.delete-cart') | translate
            }}</span>
          </button>
          <button
            (click)="confirm()"
            [disabled]="vm.notReadyForSimulation || orderQuantities.invalid || orderQuantitiesIsPending"
            color="primary"
            data-test="cart__checkout"
            mat-flat-button
          >
            <mat-icon>arrow_forward</mat-icon>
            <span *ngIf="cart.type !== orderTypes.returnableOrder; else checkReturn">{{ 'cart.check-cart' | translate }}</span>
          </button>
        </div>
      </mat-card-actions>

      <div *ngIf="vm.validationMessages as validationFeedback">
        <div
          *ngFor="let feedback of validationFeedback"
          [attr.data-test]="'cart__error-feedback-' + feedback.errorCode"
          [class]="'notification-' + ((feedback.severityLevel | lowercase) || 'error')"
          class="cart__error-feedback notification text--input-small spacing--margin-none-bottom flex--row"
        >
          <mat-icon class="flex--align-self-center">
            {{ (feedback.severityLevel | lowercase) || 'error' }}
          </mat-icon>
          <div>{{ feedback.message }}</div>
        </div>
      </div>
    </mat-card>
  </div>
</ng-container>

<ng-template #returnTitle>
  <p class="spacing--margin-none-vertical text--bold text--body">{{ 'cart.your-return' | translate }}</p>
</ng-template>

<ng-template #checkReturn>
  <span>{{ 'cart.check-return' | translate }}</span>
</ng-template>

<ng-template #deleteReturn>
  <span>{{ 'cart.delete-return' | translate }}</span>
</ng-template>
